export const Authendpoint = {
  loginApi: `/admin/auth/login`,
  OtpVerify:`/admin/auth/otp-verify`,
  logout: `admin/log-out`,
};
